import React from 'react'
import { Layout, Spin } from 'antd'
import { withRouter, Route, Redirect } from 'react-router-dom'
import { getCookieNew, setCookieNew, getParmUrl } from '../public/utils'
import { ajaxApi } from '../server/index'
import './main-page.less'
import qs from 'querystring'
import common from '@/public/common'

class MainPageRoute extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      status: 'pending'
    }
  }
  componentDidMount () {
    this.setState({ status: 'logged' })
    if (!getParmUrl('opration')&&getCookieNew('supplier_code')) {
      this.getSupplierInfo()
    }
  }
  componentWillUnmount () {
    this.setState = (state, callback) => {
    }
  }

  getSupplierInfo = async () => {
    try{
      let res = await ajaxApi({
        url: common.scpUrl+'supplier-enter/query-suppliers-by-account',
        params: {
          id: getCookieNew('accountId'),
          businessId:getCookieNew('businessId'),
          supplierCode:getCookieNew('supplier_code'),
        },
      })
      if (res.status === 200 && res.data) {
        setCookieNew('supplierinfo', encodeURI(JSON.stringify({
          ...res.data[0],
          // sid: getCookieNew('sid'),
        })), 3)
      }
    }catch(err){
      
    }
  }

  render () {
    const { status } = this.state
    const { component, ...rest } = this.props

    if (status === 'pending') return <div className="full-center"><Spin /></div>
    if (status === 'logout') return <Redirect to='/login' />
    if (status === 'logged') return <Route {...rest} render={props => React.createElement(component, props)} />
  }
}

export default withRouter(MainPageRoute)



// WEBPACK FOOTER //
// ./src/layout/main-page.js